import axios from "axios";

export const getCategoryTree = async () => {
  const url = `${process.env.EJ_APPS_API_HOSTNAME}/e6t/v2/mobile/category-tree`;
  const response = await axios.get(url);
  return response.data;
};

export const getPropertyTree = async ({ categoryId, tradeTypeId }) => {
  if ((!categoryId && categoryId !== 0) || (!tradeTypeId && tradeTypeId !== 0)) {
    throw new Error(`categoryId and tradeTypeId must not be undefined, ${categoryId}, ${tradeTypeId}`);
  }

  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v2/listing/filter/fields?categoryId=${categoryId}&tradeTypeId=${tradeTypeId}`;
  const response = await axios.get(url);
  return response.data;
};
